module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_null_0@3x.2c8c0ec6.png";